// Shared ausstattung config: display labels for facilities (Ausstattung).
// Icons are mapped in the consuming component.

export const AUSSTATTUNG_ALL = [
  // === ALLGEMEIN ===
  { value: 'grill',        de: 'Grill',              group: 'allgemein' },
  { value: 'picknicktische', de: 'Picknicktische',   group: 'allgemein' },
  { value: 'toilette',     de: 'Öffentliche Toilette',group: 'allgemein' },
  { value: 'wickelbereich',de: 'Wickelbereich',       group: 'allgemein' },
  { value: 'tiere',        de: 'Tiere',               group: 'allgemein' },
  { value: 'wasserspender',de: 'Wasserspender',        group: 'allgemein' },
  { value: 'bank',         de: 'Sitzbank',             group: 'allgemein' },
  { value: 'dusche',       de: 'Dusche',               group: 'allgemein' },
  { value: 'wifi',         de: 'WiFi',                 group: 'allgemein' },

  // === SPIELPLATZ ===
  { value: 'rutschen',     de: 'Rutsche',              group: 'spielplatz' },
  { value: 'schaukeln',    de: 'Schaukel',             group: 'spielplatz' },
  { value: 'wasserspiele', de: 'Wasserspiele',         group: 'spielplatz' },
  { value: 'wippe',        de: 'Wippe',                group: 'spielplatz' },
  { value: 'federwippe',   de: 'Federwippe',           group: 'spielplatz' },
  { value: 'sandkasten',   de: 'Sandkasten',           group: 'spielplatz' },
  { value: 'karussell',    de: 'Karussell',            group: 'spielplatz' },
  { value: 'klettergeruest', de: 'Klettergerüst',      group: 'spielplatz' },

  // === GASTRONOMIE ===
  { value: 'restaurant',   de: 'Restaurant',           group: 'gastro' },
  { value: 'kiosk',        de: 'Kiosk',                group: 'gastro' },
  { value: 'cafe',         de: 'Café',                 group: 'gastro' },
  { value: 'bar',          de: 'Bar',                  group: 'gastro' },

  // === SPORT & SPIEL ===
  { value: 'fussball',     de: 'Fussball(feld)',        group: 'sport' },
  { value: 'basketball',   de: 'Basketball',           group: 'sport' },
  { value: 'tischtennis',  de: 'Tischtennis',          group: 'sport' },
  { value: 'billard',      de: 'Billard',              group: 'sport' },
  { value: 'tischfussball',de: 'Tischfussball',        group: 'sport' },
  { value: 'tennis',       de: 'Tennis',               group: 'sport' },
  { value: 'padel',        de: 'Padel',                group: 'sport' },
  { value: 'minigolf',     de: 'Minigolf',             group: 'sport' },
  { value: 'curling',      de: 'Curling',              group: 'sport' },
  { value: 'halfpipe',     de: 'Halfpipe',             group: 'sport' },
  { value: 'obstacles',    de: 'Hindernisparcours',    group: 'sport' },
  { value: 'sportgeraete', de: 'Sportgeräte',          group: 'sport' },
  { value: 'achterbahn',   de: 'Achterbahn',           group: 'sport' },

  // === VERLEIH ===
  { value: 'schlittschuh-verleih', de: 'Schlittschuh-Verleih', group: 'verleih' },
  { value: 'fahrzeugverleih',      de: 'Fahrzeugverleih',      group: 'verleih' },
  { value: 'spielverleih',         de: 'Spielverleih',         group: 'verleih' },
  { value: 'eishockeyverleih',     de: 'Eishockey-Verleih',    group: 'verleih' },

  // === SCHWIMMBAD ===
  { value: 'schwimmerbahn',de: 'Schwimmerbahn',        group: 'schwimmbad' },
  { value: 'wasserrutsche',de: 'Wasserrutsche',        group: 'schwimmbad' },
  { value: 'sprungbrett',  de: 'Sprungbrett',          group: 'schwimmbad' },
  { value: 'strudel',      de: 'Strudel / Whirlpool',  group: 'schwimmbad' },
  { value: 'pool',         de: 'Pool',                 group: 'schwimmbad' },
  { value: 'sauna',        de: 'Sauna',                group: 'schwimmbad' },

  // === UNTERHALTUNG / DIGITAL ===
  { value: 'games',        de: 'Games',                group: 'digital' },
  { value: 'bowling',      de: 'Bowling',              group: 'digital' },
  { value: 'arcade',       de: 'Arcade',               group: 'digital' },
  { value: 'interaktiv',   de: 'Interaktiv',           group: 'digital' },
  { value: 'augmented-reality', de: 'Augmented Reality', group: 'digital' },
  { value: 'virtual-reality',   de: 'Virtual Reality',   group: 'digital' },

  // === BIBLIOTHEK ===
  { value: 'buecher',      de: 'Bücher',               group: 'bibliothek' },
  { value: 'hoerbuecher',  de: 'Hörbücher',            group: 'bibliothek' },
];

// Gruppen der Ausstattung – Reihenfolge und Beschriftung im Bearbeiten-Formular
// und in der Admin-Verwaltung.
export const FACILITY_GROUPS = [
  { key: 'allgemein',  de: 'Allgemein' },
  { key: 'spielplatz', de: 'Spielplatz' },
  { key: 'gastro',     de: 'Gastronomie' },
  { key: 'sport',      de: 'Sport & Spiel' },
  { key: 'verleih',    de: 'Verleih' },
  { key: 'schwimmbad', de: 'Schwimmbad / Wasser' },
  { key: 'digital',    de: 'Unterhaltung' },
  { key: 'bibliothek', de: 'Bibliothek' },
];